module.exports = __webpack_public_path__ + "img/return-left.15792a8a.svg";